import BaseServiceV2 from "../BaseServiceV2";
import ApiUrl from '../ApiUrl';
import { de } from "date-fns/locale";

class EbasvuruTenantService extends BaseServiceV2 {
    constructor() {
        super(ApiUrl.PublicDomain + ApiUrl.controller.EbasvuruTenant);
        this.token = null; // Define token as a class property
    }

    setToken(newToken) {
        this.token = newToken; // Method to set token if needed
    }


    async Projesi(data) {

        return await this.easyGet(ApiUrl.publicEndpoint.Projesi, data, this.token);
    }

    async Ilceler(data) {
        return await this.easyGet(ApiUrl.publicEndpoint.Ilceler, data, this.token);
    }

    async Sehir(data) {
        return await this.easyGet(ApiUrl.publicEndpoint.Sehir, data, this.token);
    }

    async Isler(data) {
        return await this.easyGet(ApiUrl.publicEndpoint.Isler, data, this.token);
    }

    async baseget(props) {

        return await this.easyGet(props.endPoint, props.data, this.token);
    }

    async SendSMS(data) {

        return await this.fullPathPost(ApiUrl.publicEndpoint.SendSMS, data, this.token);
    }



    async basePost(props) {

        return await this.easyPost(props.endPoint, props.data, this.token);
    }

}

const EbasvuruTenantservice = new EbasvuruTenantService();
export default EbasvuruTenantservice;
